module.exports = __webpack_public_path__ + "static/23rd-18c9b9bd779c438e5ab64605ed4605b3.png";